export const PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME =
  'audio-message-bubble-playing';

export const SHARING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME =
  'audio-message-bubble-sharing';
